export const meetsMinLevel = (level, minLevel, gelistirmeConsole) => (
  Boolean(gelistirmeConsole) || Number(level) >= Number(minLevel)
);
